import { render, staticRenderFns } from "./IconPending.vue?vue&type=template&id=37dfc37e&"
import script from "./IconPending.vue?vue&type=script&lang=js&"
export * from "./IconPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dfc37e')) {
      api.createRecord('37dfc37e', component.options)
    } else {
      api.reload('37dfc37e', component.options)
    }
    module.hot.accept("./IconPending.vue?vue&type=template&id=37dfc37e&", function () {
      api.rerender('37dfc37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPending.vue"
export default component.exports